<div class="h-100">
<div class="d-flex justify-content-end w-100 py-3">       
         <div>
            <app-button class="flex-fill"
             (click)="createMsgifyUserPopup($event)" 
             [customClass]="'primary'"
             [buttonLabel]="'Create Msgify User'"></app-button>
         </div>
    </div>
 <div class="grid-height">
  <app-ag-grid
    id="customerList"
    class="d-flex flex-column h-100 min-height-150"
    [dataModel]="agGridDataModelMessagifyUser"
    [rowData]="rowData"
    [isFilter]="true"
    [pageSize]="MessagifyUserDatamodal.pageSize"
    [page]="MessagifyUserDatamodal.pageNumber"
    [totalRecords]="totalRecords"
    (gridReady)="onGridReady($event)"
    (onPageSizeUpdated)="onChangePage($event)"
    (onPageSizeChanged)="getAll()"
    (onDeleteIconClick)="onDelete($event)"
    [rowHeight]="40">
  </app-ag-grid>
</div>
</div>